<template>
  <naj-input
    v-bind="attrs"
    v-on="$listeners"
  ></naj-input>
</template>

<script>
export default {
  name: 'NajReadonlyInput',
  computed: {
    attrs() {
      const { disabled, validates, ...attrs } = this.$attrs;
      attrs.readonly = true;
      attrs.clearable = false;
      attrs.validates = this.isRequired ? 'required' : '';
      return attrs;
    },
    isRequired() {
      const validations = this.$attrs.validates || '';
      return validations.includes('required') || validations.includes('conditionalRequired:true');
    },
  },
};
</script>

<style lang="scss" scoped></style>
